import { PageItemAPI as API } from '@src/api/types';
import { PageItemAPI as Data } from '@src/types';

import generateTranslations from './translations';

const Factory = (api: API): Data => {
  return {
    name: generateTranslations(api.name),
    url: api.address,
    params: api.query,
    produces: api.produces,
  };
};

export default Factory;
